import { ReactElement } from 'react';

import { InfoOutline } from '@calm-web/icons';

import { ChildrenWrapper, CloseButton, Wrapper } from './styles';
import { BannerProps } from './types';

const Banner = ({
	backgroundColor = 'bannerBg',
	textColor = 'bannerText',
	Icon = InfoOutline,
	onDismiss,
	fullPageWidth = false,
	addMargins = false,
	className,
	textAlign = 'left',
	fontWeight = 'normal',
	children,
	...props
}: BannerProps): ReactElement => {
	return (
		<Wrapper
			{...props}
			$backgroundColor={backgroundColor}
			$textColor={textColor}
			$addMargins={addMargins}
			$fullPageWidth={fullPageWidth}
			className={className}
			$textAlign={textAlign}
			$fontWeight={fontWeight}
		>
			{Icon ? <Icon /> : null}
			<ChildrenWrapper>{children}</ChildrenWrapper>
			{onDismiss ? <CloseButton onPress={onDismiss} aria-label="close" color={textColor} /> : null}
		</Wrapper>
	);
};

export default Banner;
